import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import DatePicker from 'react-datepicker';
const Moment = require('moment');
import { Row, Button } from 'react-bootstrap';
const isArray = require('lodash/isArray');

const Strings = require('../../../../app/shared/Strings');
const ChannelStore = require('../../stores/channel_store_reflux');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
import TimeseriesChart from '../chart/TimeseriesChart';
import { ChartTotalsBoxRow, ChartTotalsBox, ChartTotalsBoxItem } from '../chart/ChartTotalsBox';

const propTypes = {
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    className: PropTypes.string
};

const defaultProps = {
    className: ""
};

class ProjectShareRangeChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getStateChannel(props.channelId),
            analyticsStoreState: AnalyticsStore.getState(),
            startDate: Moment().subtract(1, 'M').date(1).toDate(),
            endDate: Moment().date(1).toDate(),
            shareRangeActionId: null
        };

        this.getAnalytics = this.getAnalytics.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onRangeUpdate = this.onRangeUpdate.bind(this);

        this.unsubscribes = [
            AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this))
        ];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.projectId !== this.props.projectId) {
            const projectStats = this.state.analyticsStoreState.projectShareRange[this.props.projectId];
            if (!!projectStats && isArray(projectStats.timeseriesCol) && projectStats.timeseriesCol.length > 0) {
                this.setState({
                    startDate: Moment(projectStats.timeseriesCol[1]).toDate(),
                    endDate: Moment(projectStats.timeseriesCol[projectStats.timeseriesCol.length-1]).toDate(),
                });
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getAnalytics(projectId) {
        const shareRangeActionId = uuid.v4();
        this.setState({ shareRangeActionId: shareRangeActionId }, () => {
            AnalyticsActions.getProjectShareRange(
                shareRangeActionId,
                {
                    projectId: projectId,
                    startDate: Moment(this.state.startDate),
                    endDate: Moment(this.state.endDate)
                }
            );
        });
    }

    onChannelStoreChange(state) {
        this.setState({
            channelStoreState: ChannelStore.getStateChannel(this.props.channelId),
        })
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.shareRangeActionId) {
            additionalState.shareRangeActionId = null;
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    onStartDateChange(date) {
        this.setState({ startDate: date });
    }

    onEndDateChange(date) {
        this.setState({ endDate: date });
    }

    onRangeUpdate(e) {
        this.getAnalytics(this.props.projectId);
    }

    render() {
        const projectStats = this.state.analyticsStoreState.projectShareRange[this.props.projectId];
        if (!this.state.channelStoreState.initialized) {
            return (null);
        }

        const currentChannel = this.state.channelStoreState.channel;
        if (!currentChannel) {
            console.error(`ProjectShareRangeChart: Channel ${this.props.channelId} not found in store.`);
            return null;
        }

        return (
            <div className={`${this.props.className}`}>
                <Row className="margin-bottom-lg">
                    <div className="col-12 col-sm-5 margin-bottom-sm">
                        <label className="label-form margin-right-sm">
                            {Strings['en'].common.START_DATE}
                        </label>
                        <DatePicker
                            className="margin-right-md"
                            selected={this.state.startDate}
                            onChange={this.onStartDateChange}
                            minDate={Moment(currentChannel.created_at).toDate()}
                            maxDate={new Date()}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                        />
                    </div>
                    <div className="col-12 col-sm-5 margin-bottom-sm">
                        <label className="label-form margin-right-sm">
                            {Strings['en'].common.END_DATE}
                        </label>
                        <DatePicker
                            className="margin-right-md"
                            selected={this.state.endDate}
                            onChange={this.onEndDateChange}
                            minDate={Moment(currentChannel.created_at).toDate()}
                            maxDate={new Date()}
                            dateFormat="MM/YYYY"
                            showMonthYearPicker
                        />
                    </div>
                    <div className="col-12 col-sm-2 margin-bottom-sm">
                        <Button
                            disabled={!!this.state.shareRangeActionId}
                            onClick={this.onRangeUpdate}
                        >
                            {Strings['en'].common.UPDATE}
                        </Button>
                    </div>
                </Row>
                {(!!projectStats) ?
                    <div className="margin-bottom-lg">
                            <TimeseriesChart
                                id="project-shares-range-chart"
                                height={300}
                                labelShow={false}
                                legendShow
                                yInt
                                columns={[projectStats.timeseriesCol, projectStats.sharesCol]}
                                xTickFormat="%Y-%m"
                            />
                            <ChartTotalsBoxRow>
                                <ChartTotalsBox title="Totals" className="chart-totals-wide margin-bottom-lg">
                                    {(typeof projectStats.sharesTotal === 'number') &&
                                        <ChartTotalsBoxItem label={Strings['en'].analytics.overview.share_stats.TOTAL_UNIQUE_SHARES} value={projectStats.sharesTotal} />
                                    }
                                    {(typeof projectStats.sharesNonUniqueTotal === 'number') &&
                                        <ChartTotalsBoxItem label={Strings['en'].analytics.overview.share_stats.TOTAL_SHARES} value={projectStats.sharesNonUniqueTotal} />
                                    }
                                </ChartTotalsBox>
                            </ChartTotalsBoxRow>
                    </div>
                    :
                    <div className="margin-bottom-xl font-style-italic text-center">
                        {Strings['en'].analytics.overview.share_stats.UPDATE_PROMPT}
                    </div>
                }
                </div>
        );
    }
}

ProjectShareRangeChart.propTypes = propTypes;
ProjectShareRangeChart.defaultProps = defaultProps;

export default ProjectShareRangeChart;